export type EventType =
  | "posedCard"
  | "playedCard"
  | "passed"
  | "playerTurn"
  | "null"
  | "roundWin"
  | "gameWin"
  | "roundDraw"
  | "roundBlocked"
  | "roundInvalid"
  | "shuffle";

export type GameStateStr =
  | "dsp"
  | "ept"
  | "epp"
  | "eppds"
  | "crb"
  | "crw"
  | "wp"
  | "gwc"
  | "idle";

export type BoardSide = "left" | "right" | "posed";

export interface Board {
  cardPosed: boolean;
  posedCard: number;
  leftBoard: number[];
  rightBoard: number[];
  leftSuit: number;
  rightSuit: number;
}

export interface GameEvent {
  eventType: EventType;
  player: number;
  playersCardsRemaining: [number, number, number, number];
  playerWins: [number, number, number, number];
  playerNames: [string, string, string, string];
  playerHands: [number[], number[], number[], number[]];
  card: number;
  boardSide: BoardSide;
  board: Board | null;
  gameState: GameStateStr;
  poseModeDoubleSix: boolean;
  wonKey: boolean;
}

export interface CardChoice {
  card: number;
  boardSide: BoardSide;
}

export const EmptyDomino = 29;
export const PartnerPose = 30;
export const DoubleSixIndex = 27;

export type GameMode = "partner" | "cutthroat";
export type ConnectionType = "online" | "local";
export type ActionType = "play" | "spectate";

export interface GameMeta {
  gameId?: string;
  dominoGameMode?: GameMode;
  randomSeed?: number;
  actionType?: ActionType;
  gameURL?: string;
  connectionType?: ConnectionType;
  webSocketToken?: string;
}

export function emptyBoard(): Board {
  return {
    cardPosed: false,
    posedCard: 0,
    leftBoard: [],
    rightBoard: [],
    leftSuit: 0,
    rightSuit: 0,
  };
}

export function emptyGameEvent(): GameEvent {
  return {
    eventType: "null",
    player: 0,
    playersCardsRemaining: [0, 0, 0, 0],
    playerWins: [0, 0, 0, 0],
    playerNames: ["You", "Sammy", "Waz", "Riles"],
    playerHands: [[], [], [], []],
    card: 0,
    boardSide: "posed",
    board: emptyBoard(),
    gameState: "dsp",
    poseModeDoubleSix: false,
    wonKey: false,
  };
}
